import React from 'react';
import { Link, useParams } from 'react-router-dom';
import TopBar from '../../../global/TopBar';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/20/solid';

const Dashboard = () => {
  const { restaurantId } = useParams();

  return (
    <>
      <TopBar />
      <div className="container mx-auto px-4 py-8 text-white">
        <h1 className="text-3xl font-bold mb-8">Restaurant Dashboard</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link to={`/food/restaurant/${restaurantId}/manage/dishes`} className="bg-sec-dark p-6 rounded-lg shadow-md hover:bg-opacity-80 transition-colors duration-200">
            <h2 className="text-xl font-semibold mb-2">Manage Dishes</h2>
            <p className="text-pri-gray">View, add, edit, or delete dishes</p>
          </Link>
          {/* Add more dashboard items as needed */}
        </div>
      </div>
    </>
  );
};

export default Dashboard;